export const kkTranslations = {
	common: {
		required: 'Міндетті аймақ',
		continue: 'Жалғастыру',
		birth_date: 'Туған күні',
		invalid_email: 'Қате email',
		first_name: 'Аты',
		last_name: 'Тегі',
		email: 'Пошта',
		phone_number: 'Телефон нөмірі',
		page_not_found: 'Бет табылмады',
		pay: 'Төлеу',
		payed: 'Төленді',
		not_payed: 'Төленбеді',
		free: 'Тегін',
		open: 'Ашу',
		or: 'немесе',
		cancel: 'Бас тарту'
	},
	login: {
		enter: 'Жүйеге кіру',
		welcome_back: 'Қайта оралуыңызбен!',
		enter_email: 'Поштаны енгізіңіз',
		wrong_email: 'Қате электрондық пошта',
		email_does_not_exist: 'Бұл электрондық пошта жоқ',
		dont_have_account: 'Аккаунтыңыз жоқ па?',
		sign_up: 'Тіркеліңіз',
		sign_in_with: '{{platform}} арқылы жалғастыру',
		get_to_know_your_potential:
			'Өзіңіздің жаңа қырларыңызды бүгін-ақ ашыңыз!',
		pass_test_and_get_results:
			'Тесттен өтіп, жеке нәтижелеріңізді поштаңызға алыңыз! Тіркелу бар болғаны 10 секунд уақыт алады.'
	},
	register: {
		sign_up: 'Тіркелу',
		sign_up_for_test: 'Тестке тіркелу',
		already_have_account: 'Аккаунтыңыз бар ма?',
		email_already_in_use: 'Бұл пошта қолданыста',
		enter_valid_number: 'Жарамды нөмірді енгізіңіз',
		login: 'Кіру'
	},
	otp: {
		invalid_otp: 'Қате код, қайта енгізіп көріңіз',
		enter_otp:
			'<0>{{email}}</0> поштасына жіберілген алты таңбалы кодты енгізіңіз',
		resend_available_in:
			'Жаңа кодты {{countdown}} секундтан кейін қайта ала аласыз',
		resending: 'Кодыңыз жіберілуде',
		resend: '6 таңбалы кодты поштаға қайта жіберу'
	},
	instructions: {
		get_started: 'Бастау',
		sign_up_completed: 'Тіркелу <0>сәтті</0> өтті',
		proceed_to_test: 'Енді тестілеуден өте аласыз',
		make_sure_have_time:
			'15-20 минут бос уақытыңыз бар екеніне көз жеткізіңіз',
		test_consists_of_100_questions: 'Тест 100 сұрақтан тұрады',
		try_to_spend_20_seconds:
			'Әр сұраққа 20 секундтан артық уақыт бөлмеуге тырысыңыз',
		no_right_or_wrong_answers:
			'Мұнда дұрыс немесе бұрыс жауаптар жоқ — жай ғана шынайы жауап беріңіз'
	},
	profile: {
		my_reports: 'Менің нәтижелерім',
		settings: 'Профиль баптаулары',
		logout: 'Шығу',
		hello: 'Жеке ақпарат',
		save: 'Өзгерістерді сақтау',
		cancel: 'Бас тарту',
		profile_edit: 'Профильді өңдеу',
		update_success: 'Сіздің деректеріңіз сақталды',
		update_error: 'Сіздің деректеріңіз сақталмады',
		test_breakdown: 'Тестті талдау'
	},
	result: {
		full_report: 'Толық нәтижені алу',
		demo_talents: 'Сенің 3 үздік талантың',
		prev_question: 'Алдыңғы сұрақ',
		note: 'Интуицияңызға сеніңіз! Бұл тестте сіздің ойыңызға бірінші келген жауапты белгілеу қажет.'
	},
	payment: {
		one_time_payment: 'Тест нәтижесін толық алу үшін бір реттік төлем',
		access_through_code:
			'Активация кодын пайдаланып, тесттің толық нәтижесін алыңыз',
		dont_have_access_code: 'Активация коды жоқ па?',
		get_access_code: 'Кодты менеджерден алу'
	},
	report: {
		from: 'Нәтиже:',
		retake_test: 'Тестті қайта тапсыру',
		my_reports: 'Менің тест нәтижелерім',
		empty_reports: 'Сізде әлі тест нәтижелері жоқ',
		did_not_pass_test:
			'Сіз әлі тест тапсырған жоқсыз. Нәтижелерді көру үшін тестті тапсырыңыз.',
		full_access_congrats: 'Құттықтаймыз, сіз толық нұсқаны аштыңыз!',
		send_to_email: 'Нәтижелер сіздің электронды поштаңызға жіберілді',
		full_view: 'Толық нәтижені көру',
		full_report: 'Толық нәтиже',
		download_report: 'Нәтижені жүктеу'
	},
	errors: {
		unknown: 'Белгісіз қате орын алды.'
	},
	assessment_plans: {
		assess_your_talents: 'Таланттарыңызды бағала',
		learn_your_strength: 'Мықты қаситтеріңізді біліп, оларды дамытыңыз',
		increase_involvment: 'Көбірек жұмысқа қызығушылық таныту',
		increase_productivity: 'Еңбек тиімділігінің артуы',
		increase_life_quality: 'Өмір сүру сапасының жақсаруы',
		buy_report: 'Нәтижені сатып алу',
		buy_full_report: 'Толық нәтижені сатып алу',
		six_times: '6 eсе',
		three_times: '3 eсе',
		most_popular: 'Cұранысқа ие',
		safe_payment: 'Қауіпсіз төлем',
		instant_access: 'Төлемнен кейін лезде қол жеткізу'
	},
	demo_report: {
		congrats:
			'құттықтаймыз! Сіз өзіңіздің ерекше қабілеттеріңізді аштыңыз.',
		sequence_of_strengths:
			'Бұл таланттар сізді айрықша тұлға етеді және дамуға бірегей мүмкіндіктер ашады.',
		your_strengths: 'Сізді алға жетелейтін қасиеттеріңіз',
		concentrate_on: 'Өзіңіздің мықты қасиеттеріңізге назар аударыңыз',
		your_biggest_actives:
			'Сіздің {{number}} негізгі қасиетіңіз – бұл сіздің ең үлкен артықшылықтарыңыз. Зерттеулер көрсеткендей, дәл осы қабілеттер кәсіби табысқа жету мен жеке өмірде бақытты болудың кепілі.',
		congrats_first_step:
			'Құттықтаймыз, сіз өз мүмкіндіктеріңізді ашуға алғашқы қадам жасадыңыз!',
		want_to_know_more: 'Көбірек білгіңіз келе ме? Толық нәтижеде: ',
		your_top5_talents:
			'Сіздің ең мықты 5 қабілетіңіздің егжей-тегжейлі сипаттамасы.',
		brief_overview: 'Қалған 15 мықты қасиеттеріңіздің қысқаша шолуы.',
		deep_understanding: 'Өзіңіздің қабілеттеріңізді терең түсіну.',
		open_full_report: 'Тесттің толық нәтижесін ашу',
		ai_breakdown: 'Тестті AI арқылы талдау',
		course_access: 'Курстарға қол жеткізу'
	},
	unlock_demo_report: {
		discover_strength: 'Таланттарыңыздың барлық күшін ашыңыз!',
		your_top_one: `Сіздің топ-1 талантыңыз — бұл тек бастамасы. Сіздің ішіңізде жаңа шыңдарға жетелейтін әлдеқайда көп потенциал бар. Өзіңіздің қалған негізгі таланттарыңызды біліңіз.`,
		extended_analysis:
			'Сіздің барлық ТОП-5 талантыңыздың және олардың бірегей үйлесімінің толық талдауы',
		recommendations: 'Әрбір талантты дамыту бойынша практикалық ұсыныстар',
		exact_steps: 'Таланттарды жұмыс пен өмірде қолдану үшін нақты қадамдар',
		buy_report_by_key_talents:
			'Негізгі таланттарға бойынша нәтижені сатып алу'
	},
	faq: {
		title: 'Жиі қойылатын сұрақтар',
		how_will_it_help:
			'Толық нәтижені сатып алу мен үшін қалай көмектеседі?',
		will_it_help1: `iTalent тесті сізге құнды ақпарат береді, бірақ біз сізге тек 5% көрсеттік. Біздің толық есебімізде сіздің таланттарыңыз туралы қалған 95% ақпарат қамтылған және сіз көрген нәтижеден гөрі тереңірек талдау ұсынады.`,
		will_it_help2: `Сонымен қатар, біздің тестіміз сіздің мықты қасиеттеріңізді қалай жақсартуға және оларды тиімді пайдалануға болатыныңызды көрсетеді. Сондай-ақ, сіз қай салаларда ең жоғары деңгейде жұмыс істей алатыныңызды түсінесіз.`,
		will_it_help3: `Егер сіз шынымен өзіңізді түсініп, бұдан да дамығыңыз келсе, осы материалдарды зерттеу қажет. Нәтижені сіздің бақытты, табысты және жан-жақты дамыған болашағыңызға жетелейтін картаңыз ретінде қарастырыңыз.`,

		may_i_believe: 'Нәтижелерге сенуге бола ма?',
		yes_you_can:
			'Әрине. iTalent.kz тестінің әдістемесі тұлғалық қасиеттерді анықтау үшін ғылыми-зерттеу институттарында қолданылатын зерттеулерге негізделген. Жалпы алғанда, мұндай тесттер әлемде 20 миллионнан астам адам тарапынан өтілген.',

		how_much_will_it_cost: 'Тест қанша тұрады және ол нені қамтиды?',
		first_plan: 'Бізде екі тариф бар:',
		full_report: '1. Толық нәтиже',
		report_comparison:
			'Салыстырмалы түрде, Gallup сияқты дүниежүзілік аналогтар шамамен 30 000 тг тұрады.',
		what_will_you_get: 'Сіз не аласыз:',
		you_will_get1: 'Негізгі таланттарыңыздың кең талдауы.',
		you_will_get2: 'Қалған мықты қасиеттеріңіздің қысқаша шолуы.',
		you_will_get3: 'Таланттардың толық құрылымы.',
		you_will_get4: 'Таланттарыңызды практикада қолдану бойынша ұсыныстар.',
		second_plan: '2. Топ-5 талантқа арналған нәтиже',
		perfect_for:
			'Ең мықты қасиеттеріңізді тез білгісі келетін адамдар үшін мінсіз.',
		you_will_get21: 'Сіздің бес негізгі таланттарыңыздың талдауы.',
		you_will_get22: 'Таланттарыңыздың құрылымдалған иерархиясы.',
		you_will_get23: 'Таланттардың қолдану тәсілдері',

		for_whom: 'Тест кімге пайдалы болуы мүмкін?',
		for_ambitious:
			'1. Мақсатшыл адамдар: Мақсатқа жетуді жеделдететін қасиеттерді анықтайды және кедергілерді көрсетеді.',
		for_lost:
			'2. Өзін іздейтіндер: Дұрыс даму бағытын белгілеп, өз мақсатыңызды табуға көмектеседі.',
		for_extrasense:
			'3. Интуициясына сенетіндер: Интуитивті болжамдарды тексереді және алдымен неге назар аудару керектігін көрсетеді.',
		for_graduates:
			'4. Түлектер мен студенттер: Тест сіздің мықты қасиеттеріңізге негізделген дұрыс мамандықты таңдауға көмектеседі және қателіктерден аулақ болуға мүмкіндік береді.'
	},
	chat: {
		your_completed_reports: 'Аяқталған тесттеріңіз',
		analysis_your_report:
			'Біздің AI сіздің тест нәтижелерін талдап, мықты қасиеттеріңізді толықтай ашуға көмектеседі',
		enter_message: 'Хабарламаңызды енгізіңіз...',
		ai_might_be_wrong:
			'AI қателіктер жібере алады. Маңызды ақпаратты тексеруді ұсынамыз.',
		sent: 'Жіберілді',
		sending: 'Жіберілуде...',
		error: 'Қате',
		failed_to_send_message:
			'Хабарламаны жіберуде қателік пайда болды. Қайталап көріңіз',
		discover_strength:
			'Жасанды интеллект арқылы мықты қасиеттеріңізді ашыңыз!',
		buy_full_report:
			'AI көмегімен талдау үшін сізге «Толық нәтижені» сатып алу керек.',
		start_analysis: 'AI көмегімен талдауды бастау',
		clear_history: 'Деректерді өшіру',
		history_cleared: 'Деректер өшірілді'
	},
	ab_assessment_plans: {
		// Hero section
		heroTitle: 'Сіздің нәтижелеріңіз дайын!',
		heroSubtitle:
			'Өз таланттарыңызға толық қол жеткізіп, оларды табысқа жету үшін қалай пайдалану керектігін біліңіз',

		// Preview Results
		previewTitle: 'Біз сіздің негізгі таланттарыңызды анықтадық:',
		talent1: 'Талдаушы',
		talent2: 'Стратегиялық ойлау',
		talent3: 'Ұйымдастырушы',
		previewDescription:
			'Бұл өзін-өзі тану жолыңыздың басы ғана. Әлеуетіңізді толық ашу үшін төменде тиісті нәтижені таңдаңыз.',
		recommendedAreas:
			'Сіздің таланттарыңызды қолданудың ұсынылған салалары',
		areasDescription:
			'Сіздің бірегей профиліңізге негізделген, сізге келесі кәсіби салалар өте қолайлы болады...',
		unlockInfo: 'Бұл ақпаратты толық нәтижеде ашыңыз',

		// Proof Grid
		accuracy: 'таланттарды анықтау дәлдігі',
		users: 'пайдаланушылар таланттарын ашты',
		productivity: 'қолданғаннан кейінгі өнімділік өсімі',
		recommended: 'пайдаланушылар тестті ұсынады',

		// Testimonials
		testimonialsTitle: 'Біздің пайдаланушылар не айтады',
		testimonial1:
			'iTalent толық есебінің арқасында мен өз күшті жақтарымды түсініп, тиімсіз дағдыларды дамытуға энергиямды жұмсауды тоқтаттым. Бұл ашылу сияқты болды! Енді мен дұрыс бағыттарға назар аударамын.',
		author1: 'Александра, HR-маман',
		testimonial2:
			'Біз iTalent-ті командамыз үшін қолдандық, кім қандай позицияда тиімді болатынын түсіну үшін. Таланттарға негізделген рөлдерді қайта бөлгеннен кейін, өнімділік 12%-ға өсті.',
		author2: 'Бота, компания басшысы',
		testimonial3:
			'iTalent маған екінші білім таңдауда көмектесті. Нәтижеде салалар бойынша нақты ұсыныстар болды, бұл қай бағытта жүру керектігін білмегенде өте құнды.',
		author3: 'Камила, студент',

		// Plans
		plansTitle: 'Өз нәтижеңізді таңдаңыз',
		functionsHeader: 'Функциялар',

		basicTitle: 'Үздік-5 талант',
		standardTitle: 'Толық нәтиже + AI',
		premiumTitle: 'Толық нәтиже + AI + сарапшымен онлайн талдау',

		mostPopular: 'Ең танымал',
		firstMeeting: 'Негізгі таланттарды жылдам түсіну үшін негізгі талдау',
		standardDescription: 'Кәсіби өсу үшін ең толық нәтиже мен AI талдау',
		premiumDescription:
			'Максималды нәтиже үшін сарапшының жеке кеңесі бар премиум шешім',

		// Feature names
		keyTalents: 'Негізгі таланттарды анықтау',
		talentDescription: 'Таланттар сипаттамасы',
		structuralHierarchy: 'Құрылымдық иерархия',
		applicationAreas: 'Таланттарды қолдану салалары',
		developmentRecommendations: 'Даму бойынша ұсыныстар',
		aiAnalysis: 'Жасанды интеллект көмегімен талдау',
		careerRecommendations: 'Мансаптық ұсыныстар',
		expertConsultation: 'Сарапшымен кеңес',
		instantAccess: 'Дереу қол жеткізу',

		// Feature values
		top3: 'Үздік-3',
		top5: 'Үздік-5',
		allTalents: 'Барлық таланттар',
		allTalentsWithBreakdown: 'Барлық таланттар, талдаумен',
		brief: 'Қысқаша',
		full: 'Толық',
		detailed: 'Егжей-тегжейлі',
		basic: 'Базалық',
		personalized: 'Дербестендірілген',
		thirtyMinutes: '60-90 минут',

		// Chips
		top3talents: 'Үздік-3 талант',
		top5talents: 'Үздік-5 талант',
		basicDescription: 'Негізгі сипаттама',
		fullAnalysis: 'Толық талдау',
		recommendations: 'Ұсыныстар',
		aiBreakdown: 'ЖИ талдауы',
		consultation: 'Кеңес беру',
		personalBreakdown: 'Жеке талдау',

		// Features list items
		feature_basic_1: 'Үздік-3 таланттарыңыз',
		feature_basic_2: 'Әр талантқа қысқаша сипаттама',
		feature_basic_3: 'Негізгі құрылымдық иерархия',
		feature_basic_4: 'Даму бойынша жалпы ұсыныстар',
		feature_basic_5: 'Төлемнен кейін дереу қол жеткізу',

		feature_standard_1: 'Үздік-5 негізгі таланттарыңыз',
		feature_standard_2: 'Әр талантқа толық талдау',
		feature_standard_3: 'Таланттарыңызды қолдану салалары',
		feature_standard_4: 'Даму бойынша нақты ұсыныстар',
		feature_standard_5: 'Егжей-тегжейлі құрылымдық иерархия',
		feature_standard_6: 'Негізгі мансаптық ұсыныстар',
		feature_standard_7: 'Төлемнен кейін дереу қол жеткізу',

		feature_premium_1: 'Барлық таланттарыңызды талдау',
		feature_premium_2: 'Нәтижелеріңіздің ЖИ талдауы',
		feature_premium_3: 'Негізгі таланттардың егжей-тегжейлі талдауы',
		feature_premium_4: 'Барлық күшті жақтарыңыздың шолуы',
		feature_premium_5: 'Таланттар иерархиясының толық құрылымы',
		feature_premium_6: 'Таланттарды қолданудың егжей-тегжейлі әдістері',
		feature_premium_7: 'Дербестендірілген мансаптық ұсыныстар',
		feature_premium_8: 'Сарапшымен 60-90 минуттық онлайн талдау',
		feature_premium_9: 'Төлемнен кейін дереу қол жеткізу',

		// Buttons
		selectButton: 'Таңдау',
		buyReportButton: 'Нәтижені сатып алу',
		buyFullReportButton: 'Толық нәтижені сатып алу',
		buyFullReportButtonWithBreakdown: 'Толық нәтижені талдаумен сатып алу',
		securePayment: 'Қауіпсіз төлем',

		// Guarantee
		guaranteeTitle: '100% қанағаттану кепілдігі',
		guaranteeText:
			'Егер нәтиже сіздің күткеніңізді ақтамаса, біз 14 күн ішінде ақшаңызды қайтарамыз.',

		// Upgrade callout
		limitedOffer: 'Шектеулі ұсыныс',
		upgradeTitle: 'Тестіңізден максимум алыңыз',
		upgradeDescription:
			'Сіз тестті өтіп, өзін-өзі тану жолындағы алғашқы қадамды жасадыңыз. Өзіңізге инвестиция салыңыз және барлық таланттарыңызды ашуға көмектесетін егжей-тегжейлі нәтижені алыңыз!',
		getFullReportButton: 'Толық нәтижені алу',

		// FAQ
		faqTitle: 'Жиі қойылатын сұрақтар',
		faq1_question: 'Тарифтер арасындағы айырмашылық неде?',
		faq1_answer:
			'Базалық тариф 3 негізгі талант туралы түсінік береді, Стандартты - оларды қолдану бойынша ұсыныстармен 5 талант туралы, ал Премиум барлық таланттардың толық талдауын, дербестендірілген ұсыныстарды және сарапшымен кеңесуді қамтиды.',
		faq2_question: 'Тест нәтижелері қаншалықты дәл?',
		faq2_answer:
			'iTalent заманауи психометриялық әдістемелер негізінде әзірленген және 25 000-нан астам адам үлгісінде расталған. Тест таланттар мен тұлғаның күшті жақтарын анықтауда жоғары дәлдікті (98%) көрсетеді.',
		faq3_question: 'Нәтижеге қол жеткізуді қаншалықты тез аламын?',
		faq3_answer:
			'Есебіңізге қол жеткізу төлем сәтті өткеннен кейін бірден беріледі. Оны онлайн қарауға немесе PDF форматында жүктеп алуға болады.',
		faq4_question: 'Тест нәтижелерімен не істеу керек?',
		faq4_answer:
			'Таңдалған тарифке байланысты, таланттарыңызды қолдану бойынша әртүрлі ұсыныстар аласыз. Нәтижелерді мансап жолын таңдау, қазіргі жұмыстағы тиімділікті арттыру, өзін-өзі дамыту немесе кәсіби қайта бағдарлау үшін пайдалана аласыз.',
		faq5_question: 'Неге толық нәтижені сатып алу керек?',
		faq5_answer:
			'Базалық нәтиже тек негізгі таланттарыңыз туралы жалпы түсінік береді, ал толық нәтиже барлық күшті жақтарыңыздың егжей-тегжейлі талдауын, оларды қолдану бойынша нақты ұсыныстарды және дербестендірілген мансаптық кеңестерді ұсынады. Толық нәтижеге салынған инвестиция кәсіби тиімділіктің және жұмыстан қанағаттанудың артуымен өтеледі.',

		// Sticky CTA
		getMyReport: 'Менің есебімді алу',

		// Footer
		footerText: '© 2024 iTalent.kz - Өз әлеуетіңізді ашыңыз'
	},
	survey: {
		discount: 'ЖЕҢІЛДІК {{percentage}}%',
		take_survey_get_discount: 'Сауалнамаға қатысып, жеңілдік алыңыз!',
		answer_questions_get_discount:
			'Таланттарыңыз туралы бірнеше сұраққа жауап беріп, кез келген тарифке {{percentage}}% жеңілдік кодын алыңыз',
		take_short_survey: 'Қысқа сауалнамаға қатысу',
		your_discount_code: 'Сіздің жеңілдік кодыңыз қолдануға дайын',
		use_code_at_checkout:
			'Сіздің жеңілдік кодыңыз төлем кезінде автоматты түрде қолданылады',
		short_survey_about_talents: 'Таланттарыңыз туралы қысқа сауалнама',
		question_1: 'Талант дамытуда сіз үшін не маңызды?',
		question_2: 'Біздің қызмет туралы қалай білдіңіз?',
		question_3: 'Қандай есептер сізді көбірек қызықтырады?',
		select_answer: 'Жауапты таңдаңыз',
		career_growth: 'Мансаптық өсу',
		personal_development: 'Жеке даму',
		financial_success: 'Қаржылық табыс',
		self_realization: 'Өзін-өзі жүзеге асыру',
		search_engines: 'Іздеу жүйелері',
		social_media: 'Әлеуметтік желілер',
		from_friends: 'Достарымнан/таныстарымнан',
		advertising: 'Жарнама',
		top_3_talents: 'Үздік 3 талант',
		top_5_talents: 'Үздік 5 талант',
		full_report: 'Толық есеп',
		thanks_for_survey: 'Сауалнамаға қатысқаныңыз үшін рахмет!',
		use_code_for_discount:
			'Тапсырыс беру кезінде {{percentage}}% жеңілдік алу үшін осы кодты пайдаланыңыз',
		submit_get_discount: 'Жіберу және жеңілдік алу',
		please_answer_all: 'Барлық сұрақтарға жауап беріңіз',
		enter_your_answer: 'Жауабыңызды енгізіңіз',
		error_submitting:
			'Сауалнаманы жіберу кезінде қате шықты. Қайталап көріңіз.'
	},
	courses: {
		courses: 'Курстар',
		courses_pass: 'Курстарды өту'
	}
};
